import React from "react";
import Render from "../../utilities/Render";

class BackToTop extends React.Component {
  constructor(props) {
    super(props);
    // Shared with subscribe-banner scroll wiring elsewhere in the app.
    window.scroll = this.handleScroll;
  }

  state = { status: "close" };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (
      document.body.scrollTop > 600 ||
      document.documentElement.scrollTop > 600
    ) {
      this.openButton();
    } else {
      this.closeButton();
    }
  };

  openButton = () => {
    this.setState({ status: "open" });
  };

  closeButton = () => {
    this.setState({ status: "close" });
  };

  scrollToTop = event => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    event.preventDefault();
    this.closeButton();
  };

  render() {
    return (
      <div className={`${this.state.status} back-to-top-wrapper print-hidden`}>
        <a href="#" className="back-to-top" onClick={this.scrollToTop}>
          <span>Back to top</span>
        </a>
      </div>
    );
  }
}

Render.Component("#back-to-top-react", null, BackToTop);

export default BackToTop;
